class DocumentReference {
dateCreated: string;
dateModified: string;
docType: string;
fileName: string;
id: string;
refId: string;
refSubType: string;
refType: string;
s3Key: string;
url: string;

constructor(options){
    this.dateCreated = options.dateCreated || "";
    this.dateModified = options.dateModified || "";
    this.docType = options.docType || "";
    this.fileName = options.fileName || "";
    this.id = options.id || "";
    this.refId = options.refId || "";
    this.refSubType = options.refSubType || "";
    this.refType = options.refType || "";
    this.s3Key = options.s3key || "";
    this.url = options.url || "";
}
}

export default DocumentReference;